import axios from "axios";
import {db_url, url_remain} from "../url";

export default function DB_Remain(token) {
    const add_url = '/document/remains'

    const formData = new FormData();
    formData.append('token', token)


    const getRemains = (controller, search) => {
        return axios.get(db_url + add_url, {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const getRemain = (data) => {
        return axios.post(url_remain + data, formData)
    }


    return {
        getRemains,
        getRemain,
    }
}
